import { getGTMEventData } from '@tracking/components/transformer';
import { EVENT_NAMES } from '@tracking/components/constants';

function loginWithPhoneFormatter({
  userId, email: userEmail, newUser, phoneNumber, whatsappConsent,
  analyticsIdentifier: userAnalyticsIdentifier,
}) {
  return [
    getGTMEventData(EVENT_NAMES.TRACK_USER, userEmail, {
      userId, userAnalyticsIdentifier,
    }),
    getGTMEventData(EVENT_NAMES.SET_USER_ATTRIBUTE, userEmail, {
      we_phone: phoneNumber,
      we_whatsapp_opt_in: whatsappConsent,
    }),
    getGTMEventData(EVENT_NAMES.REGISTER_USER, userEmail, {
      authenticationMode: 'phone_otp', newUser, userId,
    }),
  ];
}

export default loginWithPhoneFormatter;
